import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setCookie } from '../../utils/cookieUtils';
import { FEDERATE_ID_TOKEN } from '../../shared/config/authConfig';
import Spinner from '@amzn/awsui-components-console/spinner';

const CallbackPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const hashParams = new URLSearchParams(window.location.hash.slice(1));
    const idToken = hashParams.get('id_token');
    const state = hashParams.get('state');

    if (idToken) {
      setCookie(FEDERATE_ID_TOKEN, idToken, {
        path: '/',
        expires: 3600,
        secure: true,
        sameSite: 'None',
      });
    }

    const target = state && state.startsWith('/') ? state : '/';
    navigate(target, { replace: true });
  }, [navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Spinner size="large" />
    </div>
  );
};

export default CallbackPage;
